<template>
  <div>
    <div v-if="!group">
      <div class="page-header">
        <div class="cover">
          <h1 class="has-text-white is-family-secondary">Groups</h1>
        </div>
      </div>
      <div class="container section tw-mt-5">
        <div class="columns is-centered tw-text-center tw-pt-20 tw-pb-5">
          <div
            class="column is-half is-one-quarter-desktop tw-text-center tw-border-r tw-border-grey-lightest"
          >
            <b-button
              class="is-large"
              type="is-primary"
              expanded
              @click="gotoHome()"
              >{{ buttonTextJoin }}</b-button
            >
          </div>
          <div class="column is-half is-one-quarter-desktop tw-text-center">
            <b-button
              class="is-large"
              type="is-primary"
              expanded
              @click="gotoCreatGroup()"
              >{{ buttonTextCreate }}</b-button
            >
          </div>
        </div>
        <div class="columns">
          <div class="column is-12  tw-text-center">
            <router-link :to="{ name: 'home' }">Skip for now</router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container">Redirecting to your Group Page</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      buttonTextJoin: 'Join a Group',
      buttonTextCreate: 'Create a Group'
    }
  },
  mounted() {
    if (this.group) {
      this.$router.push({ name: 'groups.details' })
    }
  },
  computed: {
    ...mapState({
      group: state => state.currentGroup
    })
  },
  methods: {
    gotoHome() {
      this.$router.push({ name: 'home' })
    },
    gotoCreatGroup() {
      this.$router.push({ name: 'groups.edit' })
    }
  }
}
</script>

<style lang="sass" scoped>
.page-header
    background-size: 120%
    background-position: left bottom
</style>
